const CalendarioSection = ({ timestamp }) => (
  <section className="calendario">
    <div style={{display: 'flex', flexDirection: 'row', textAlign: 'center', alignItems: 'center', gap: '15px'}}>
      <h2>Calendário</h2>
      <p><a href='/materiais' style={{color: '#333'}}>Procurando a lista de materiais? <span style={{textDecoration: 'underline'}}>Clique aqui!</span></a></p>
    </div>
    <div className='imagens-calend' style={{display: 'flex', flexDirection: 'row', flexWrap: 'wrap', gap: '20px', justifyContent: 'center'}}>
      <img src={`assets/images/calendarios/2026/fund2a.png?time=${timestamp}`} alt="Calendário do Ensino Fundamental II - página 1"></img>
      <img src={`assets/images/calendarios/2026/fund2b.png?time=${timestamp}`} alt="Calendário do Ensino Fundamental II - página 2"></img>
    </div>
  </section>
);

export default CalendarioSection;
